"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
const _tagged_template_literal = require("@swc/helpers/_/_tagged_template_literal");
function _templateObject() {
    const data = _tagged_template_literal._([
        "\n  query subscriptionProfile {\n    customer {\n      subscriptionProfile {\n        addressId\n        address {\n          area\n          city\n          country\n          delivery\n          district\n          firstName\n          id\n          lastName\n          locality\n          province\n          region\n          streetAddress\n          zipcode\n        }\n        deliveryChannel {\n          address {\n            addressId\n            area\n            city\n            country\n            district\n            locality\n            province\n            region\n            streetAddress\n            zipcode\n          }\n          coordinates {\n            latitude\n            longitude\n          }\n          deliveryChannelId\n          deliveryMethod\n          description\n          imageUrl\n          isCodAllowed\n          isLuxury\n          orisalesId\n          telephoneNumber\n          workingHours\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.subscriptionProfileQuery = void 0;
var _fetching = require("@ori/fetching");
const subscriptionProfileQuery = exports.subscriptionProfileQuery = (0, _fetching.gql)(_templateObject());
